import ResultTable from "../../components/table/ResultTable";
import ResultHeader from "../../components/table/ResultHeader";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultBody from "../../components/table/ResultBody";
import getSettingsItem, {getSettingsSelectItem} from "./SettingsItem";

export default function SurveySettings({onValuesChange, values, defValues}) {

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 300}}>Variable</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>User Preference</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>System Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 230}}>Description</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        getSettingsItem({
                            value: values?.survey_buffer_distance,
                            defaultValue: defValues?.survey_buffer_distance,
                            onChange: (value) => {onValuesChange('survey_buffer_distance', value)},
                            label: 'Buffer Distance (ft)',
                            description: ''
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.survey_cluster_dev_ration,
                            defaultValue: defValues?.survey_cluster_dev_ration,
                            onChange: (value) => {onValuesChange('survey_cluster_dev_ration', value)},
                            label: 'Cluster Deviation Ratio',
                            description: ''
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}